import sortBy from 'lodash/sortBy';

/* sort watchers and return reviewers first */
export var sortReviewerFirst = function sortReviewerFirst(watchers) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var array = [].concat(watchers);
  return array.sort(function (a, b) {
    return a.isReviewer && !b.isReviewer ? -1 : 0;
  });
};
//# sourceMappingURL=watchers.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/watchers.js
// module id = 781
// module chunks = 0